var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.createUrl}},[(_vm.text)?_c('div',{staticClass:"icon-button icon-button--primary icon-button--text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]):_c('div',{staticClass:"icon-button icon-button--primary"},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-button__icon"},[_c('img',{attrs:{"src":"/images/icons/create.svg","alt":""}})])
}]

export { render, staticRenderFns }